/* eslint-disable complexity */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
// Libraries
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { capitalize } from 'lodash';

// Helper Methods
import { getRoleStatusOptions, getTagsValue } from '../../utils/helperMethods';

// Components
import { FormElems, Alert, GetTemplateFields } from '../';

import {
    DEFAULT_CURRENCY,
    validityOptions,
} from '../../utils/constants/commonValues';
import { SUCCESS_MESSAGES } from '../../utils/constants/toastMessages';

// Actions
import {
    updatePayLinksRequest,
    updatePayLinksError,
    sharePayLinksRequest,
    sharePayLinksError,
} from '../../containers/PaymentLink/redux/paymentLink.actions';

// Validator
import validate from './validator';

// Styles
import './viewEditPaymentLink.scss';

const ViewEditPaymentLink = props => {
    const {
        closePopup,
        paymentLinkData,
        handleSubmit,
        actionType,
        actions,
        data,
        formData,
        fetchData,
        resetPage,
        initialValues,
    } = props;
    const { updatePayLink, sharePay, templateDetails } = paymentLinkData;
    const history = useHistory();

    const { templateInfo } = data;
    const { template } = templateDetails;

    // Handle On Success of the update payment link.
    useEffect(() => {
        if (updatePayLink.isSuccess) {
            closePopup();
            fetchData({ pageIndex: 1, pageSize: 10 });
            resetPage();
            toast.info(SUCCESS_MESSAGES.UPDATE_DATA('Paylink'));
        }
        return () => {
            actions.updatePayLinksError({ error: {} });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchData, updatePayLink.isSuccess]);

    // Handle On Success of the Share Payment Link.
    useEffect(() => {
        if (sharePay.isSuccess) {
            closePopup();
            fetchData({ pageIndex: 1, pageSize: 10 });
            resetPage();
            toast.info(SUCCESS_MESSAGES.SHARED_DATA('Payment Link'));
        }
        return () => {
            actions.sharePayLinksError({ error: {} });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchData, sharePay.isSuccess]);

    // On View Transactions button action function.
    const onViewTransactions = event => {
        event.preventDefault();
        const url = `payment-link/${data.linkDataId || 1}`;
        history.push(url);
    };

    // On Cancel/Close of the popup.
    const onCancel = event => {
        event.preventDefault();
        closePopup();
    };

    // Handling of the form submit for the share and update payment link.
    function handleFormSubmit(formData) {
        if (isShareMode) {
            const reqPayload = {
                communicationDetails: {
                    email:
                        formData.sharebyemail &&
                        getTagsValue(JSON.parse(formData.sharebyemail)),
                    mobile:
                        formData.sharebysms &&
                        getTagsValue(JSON.parse(formData.sharebysms)),
                },
                linkDataId: data.linkDataId,
            };
            actions.sharePayLinksRequest(reqPayload);
        } else {
            const reqPayload = {
                linkDataId: data.linkDataId,
                linkDataStatus: formData.linkDataStatus,
                linkName: formData.linkName || data.linkName,
                remarks: formData.remarks,
                validityPeriod: parseInt(formData.validityPeriod, 10),
            };
            actions.updatePayLinksRequest(reqPayload);
        }
    }

    const isFormReadOnly = actionType === 'view';
    const isShareMode = actionType === 'share';

    return (
        <form
            className="paymentLink-view-edit"
            onSubmit={handleSubmit(handleFormSubmit)}
        >
            {isFormReadOnly && !isShareMode ? (
                <>
                    <div className="form-section">
                        <div className="form-field status-section">
                            <p className="label">Status</p>
                            <div
                                className={`status ${data.linkDataStatusView}`}
                            >
                                {data.linkDataStatusView}
                            </div>
                            <div className="lastupdate-status">
                                {data.editedBy && (
                                    <>
                                        Last Edit :{' '}
                                        <strong>
                                            {data.editedBy || '-'},{' '}
                                        </strong>
                                        {moment(data.editedOn, 'DD/MM/YYYY')
                                            .calendar()
                                            .indexOf('Today') >= 0
                                            ? 'Today'
                                            : moment(
                                                  data.editedOn,
                                                  'DD/MM/YYYY'
                                              )
                                                  .calendar()
                                                  .indexOf('Yesterday') >= 0
                                            ? 'Yesterday'
                                            : data.editedOn}
                                    </>
                                )}
                                {!data.editedBy && (
                                    <>
                                        Created By :
                                        <strong>
                                            {' '}
                                            {data.createdBy || '-'},{' '}
                                        </strong>
                                        {moment(data.createdOn, 'DD/MM/YYYY')
                                            .calendar()
                                            .indexOf('Today') >= 0
                                            ? 'Today'
                                            : moment(
                                                  data.createdOn,
                                                  'DD/MM/YYYY'
                                              )
                                                  .calendar()
                                                  .indexOf('Yesterday') >= 0
                                            ? 'Yesterday'
                                            : data.createdOn}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="form-section viewOnly">
                        <div className="form-field">
                            <p className="label">Link ID</p>
                            <p className="label-value">{data.linkId}</p>
                        </div>
                        <div className="form-field">
                            <p className="label">Created On</p>
                            <p className="label-value">{data.createdOn}</p>
                        </div>
                        <div className="form-field">
                            <p className="label">Amount</p>
                            <p className="label-value">{data.amountView}</p>
                        </div>
                    </div>
                    <div className="form-section viewOnly border-b">
                        <div className="form-field">
                            <p className="label">Validity Period</p>
                            <p className="label-value">
                                {data.validityPeriodView}
                            </p>
                        </div>
                        <div className="form-field">
                            <p className="label">Shared Count</p>
                            <p className="label-value">{data.sharedCount}</p>
                        </div>
                        <div className="form-field">
                            <p className="label">Trans. Success</p>
                            <p className="label-value">
                                {data.txnSuccessCount}
                            </p>
                        </div>
                    </div>
                    {/* Rendering product info only if the are template is set */}
                    {data.productInfo && data.productInfo.length ? (
                        <div className="form-section comment-section viewOnly">
                            <div className="form-field">
                                <p className="label">Product Information</p>
                            </div>
                        </div>
                    ) : (
                        <> </>
                    )}
                    {data.productInfo.map((item, itemIndex) => {
                        return (
                            <>
                                <div
                                    className="form-section comment-section viewOnly"
                                    key={itemIndex}
                                >
                                    <div className="form-field">
                                        <p className="label">Serial No.</p>
                                        <p className="label-value">
                                            {itemIndex + 1}
                                        </p>
                                    </div>
                                    <div className="form-field">
                                        <p className="label">Name</p>
                                        <p className="label-value">
                                            {item.name}
                                        </p>
                                    </div>
                                    <div className="form-field">
                                        <p className="label">Amount</p>
                                        <p className="label-value">
                                            {item.amount}
                                        </p>
                                    </div>
                                    <div className="form-field">
                                        <p className="label">Mandatory</p>
                                        <p className="label-value">
                                            {item.isMandatory &&
                                            item.isMandatory.length
                                                ? 'Yes'
                                                : 'No'}
                                        </p>
                                    </div>
                                </div>
                            </>
                        );
                    })}

                    {data.productInfo && data.productInfo.length ? (
                        <div className="form-section viewOnly border-b" />
                    ) : (
                        <> </>
                    )}

                    {/* Rendering template info only if the are template is set */}
                    {templateInfo && templateInfo.additionalInfo ? (
                        <div className="form-section comment-section viewOnly">
                            <div className="form-field">
                                <p className="label">Template Information</p>
                            </div>
                        </div>
                    ) : (
                        <></>
                    )}

                    {templateInfo && templateInfo.additionalInfo ? (
                        <>
                            <div className="grid-wrapper">
                                {Object.keys(templateInfo.additionalInfo).map(
                                    (key, index) => {
                                        return (
                                            <React.Fragment
                                                key={`templateInfo-${index}`}
                                            >
                                                <div className="form-field">
                                                    <p className="label">
                                                        {capitalize(key)}
                                                    </p>
                                                    <p className="label-value">
                                                        {
                                                            templateInfo
                                                                .additionalInfo[
                                                                key
                                                            ]
                                                        }
                                                    </p>
                                                </div>
                                            </React.Fragment>
                                        );
                                    }
                                )}
                            </div>
                            <div className="form-section viewOnly border-b" />
                        </>
                    ) : (
                        <></>
                    )}
                    <div className="form-section comment-section viewOnly">
                        <div className="form-field">
                            <p className="label">Comment</p>
                            <p className="label-value">{data.remarks}</p>
                        </div>
                    </div>
                </>
            ) : isShareMode ? (
                <>
                    <div className="form-section viewOnly">
                        <div className="form-field">
                            <p className="label">Link name</p>
                            <p className="label-value">{data.linkName}</p>
                        </div>
                        <div className="form-field">
                            <p className="label">Valid Period</p>
                            <p className="label-value">
                                {data.validityPeriodView}
                            </p>
                        </div>
                    </div>
                    <div className="form-section viewOnly border-b">
                        <div className="form-field">
                            <p className="label">Link ID</p>
                            <p className="label-value">{data.linkId}</p>
                        </div>
                        <div className="form-field">
                            <p className="label">Amount</p>
                            <p className="label-value">{data.amountView}</p>
                        </div>
                    </div>
                    <div className="form-section upper-space">
                        <div className="form-field">
                            <p className="label">Share by SMS</p>
                            <Field
                                name="sharebysms"
                                component={FormElems.InputTags}
                                placeholder="Enter Mobile"
                            />
                        </div>
                    </div>
                    <div className="form-section">
                        <div className="form-field">
                            <p className="label">Share by Email</p>
                            <Field
                                name="sharebyemail"
                                component={FormElems.InputTags}
                                placeholder="Enter Email ID"
                            />
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="form-section">
                        <div className="form-field">
                            <p className="label">Link Name</p>
                            <Field
                                name="linkName"
                                type="text"
                                component={FormElems.Input}
                                placeholder="Enter Name"
                            />
                        </div>
                    </div>
                    <div className="form-section">
                        <div className="form-field">
                            <p className="label">Status</p>
                            <Field
                                name="linkDataStatus"
                                options={getRoleStatusOptions()}
                                defaultSelected={
                                    formData.values &&
                                    formData.values.linkDataStatus &&
                                    formData.values.linkDataStatus.toUpperCase()
                                }
                                valueField="value"
                                labelField="label"
                                component={FormElems.Radio}
                                isDisabled={isFormReadOnly}
                            />
                        </div>
                    </div>
                    {formData &&
                    formData.values &&
                    formData.values.productInfo &&
                    formData.values.productInfo.length ? (
                        <div className="form-section">
                            <FieldArray
                                name="productInfo"
                                component={multiProductDownLink}
                                isViewMode
                            />
                        </div>
                    ) : (
                        <></>
                    )}

                    {template && template.templateId ? (
                        <>
                            <GetTemplateFields
                                templateId={template.templateId}
                                templateFields={template.fields.filter(
                                    item => item.type !== 'hidden'
                                )}
                                isViewMode={true}
                            />
                            <div className="form-section viewOnly border-b-edit" />
                        </>
                    ) : (
                        <></>
                    )}

                    <div className="form-section multiCol">
                        <div className="form-field">
                            <p className="label">Amount</p>
                            <Field
                                name="amountView"
                                type="text"
                                component={FormElems.Input}
                                placeholder="Enter Amount"
                                disabled={true}
                            />
                        </div>
                        <div className="form-field">
                            <p className="label">Validity Period</p>
                            <Field
                                name="validityPeriod"
                                placeholder="Enter Days"
                                data={validityOptions || []}
                                labelField="name"
                                valueField="value"
                                component={FormElems.Select}
                            />
                        </div>
                    </div>
                    <div className="form-section comment-section">
                        <div className="form-field">
                            <p className="label">Remarks</p>
                            <Field
                                wrapperClass="comment-input"
                                name="remarks"
                                type="textarea"
                                isDisabled={false}
                                component={FormElems.TextArea}
                                placeholder="Enter Comment"
                            />
                        </div>
                    </div>
                </>
            )}
            {updatePayLink.error && updatePayLink.error.errorMessage ? (
                <Alert>{updatePayLink.error.errorMessage}</Alert>
            ) : null}
            {sharePay.error && sharePay.error.errorMessage ? (
                <Alert>{sharePay.error.errorMessage}</Alert>
            ) : null}
            {!isShareMode ? (
                <div className="form-section action">
                    {actionType === 'view' ? (
                        <FormElems.Button
                            buttonType="primary"
                            text="VIEW TRANSACTION"
                            handleClick={onViewTransactions}
                            customClass="edit-btn"
                        />
                    ) : (
                        <>
                            <FormElems.Button
                                buttonType="secondary"
                                text="CANCEL"
                                handleClick={onCancel}
                                customClass="cancel-btn"
                            />
                            <FormElems.Button
                                buttonType="primary"
                                text="UPDATE"
                            />
                        </>
                    )}
                </div>
            ) : (
                <div className="form-section action">
                    <FormElems.Button
                        buttonType="secondary"
                        text="CANCEL"
                        handleClick={onCancel}
                        customClass="cancel-btn"
                    />
                    <FormElems.Button buttonType="primary" text="SUBMIT" />
                </div>
            )}
        </form>
    );
};

const mapStateToProps = ({ auth, paymentLinkData, form }) => ({
    auth,
    paymentLinkData,
    formData: form['view-edit-paymentLink'],
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            updatePayLinksRequest,
            updatePayLinksError,
            sharePayLinksRequest,
            sharePayLinksError,
        },
        dispatch
    ),
});

const multiProductDownLink = ({
    fields,
    meta: { error, submitFailed },
    auth,
    isViewMode,
}) => {
    if (fields.length <= 0) {
        fields.push();
    }

    return (
        <div className="col-section">
            <div className="register-section">
                {fields.map((item, index) => (
                    <>
                        <div className="form-section multiCol product-section">
                            {!isViewMode && (
                                <FormElems.Button
                                    type="button"
                                    buttonType="secondary"
                                    id={`removeNumber-${index}`}
                                    customClass="btn-remove"
                                    handleClick={() => fields.remove(index)}
                                    disabled={isViewMode}
                                />
                            )}
                            <div className="form-field">
                                <p className="label">Product Name</p>
                                <Field
                                    name={`${item}.name`}
                                    id={`${item}.name`}
                                    type="text"
                                    component={FormElems.Input}
                                    placeholder="Enter Name"
                                    disabled={isViewMode}
                                />
                            </div>
                            <div className="form-field">
                                <p className="label">Amount</p>
                                <Field
                                    name={`${item}.amount`}
                                    id={`${item}.amount`}
                                    type="number"
                                    min={0}
                                    component={FormElems.Input}
                                    placeholder="Enter Amount"
                                    disabled={isViewMode}
                                />
                            </div>
                            <div className="form-field product-section-checkbox">
                                <Field
                                    name={`${item}.isMandatory`}
                                    id={`${item}.isMandatory`}
                                    options={[
                                        {
                                            label: 'Mandatory',
                                            value: 'isMandatory',
                                            checked: false,
                                        },
                                    ]}
                                    valueField="value"
                                    labelField="label"
                                    disabled={isViewMode}
                                    isDisabled={isViewMode}
                                    component={FormElems.Checkbox}
                                />
                            </div>
                        </div>
                    </>
                ))}
            </div>
            <div className="section-title">
                {!isViewMode && (
                    <FormElems.Button
                        type="button"
                        buttonType="secondary"
                        id="add-product"
                        text={`+ Add Product`}
                        customClass="btn-small"
                        handleClick={() => {
                            fields.push();
                        }}
                    />
                )}
            </div>
        </div>
    );
};

multiProductDownLink.propTypes = {
    fields: PropTypes.object,
    meta: PropTypes.object,
    auth: PropTypes.object,
    uniqueId: PropTypes.object,
    isViewMode: PropTypes.bool,
};

ViewEditPaymentLink.propTypes = {
    handleSubmit: PropTypes.func,
    closePopup: PropTypes.func,
    actionType: PropTypes.string,
    data: PropTypes.object,
    handleOpenActionPopup: PropTypes.func,
    paymentLinkData: PropTypes.object,
    actions: PropTypes.func,
    formData: PropTypes.object,
    updatePayLink: PropTypes.object,
    fetchData: PropTypes.object,
    resetPage: PropTypes.func,
};

export default compose(
    reduxForm({
        form: 'view-edit-paymentLink',
        validate,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(ViewEditPaymentLink);
